import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'test'
})
export class TestPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/pipes/test.pipe.ts